const validator = (predicate, error = '', reference = undefined) => {
  const f = value => {
    const valid = predicate(value);
    return {
      valid: valid,
      error: valid ? undefined : error,
      value: value,
      reference: reference
    };
  };
  f.withError = error => validator(predicate, error, reference);
  f.withReference = reference => validator(predicate, error, reference);
  return f;
};

export default validator;
